module.exports = __webpack_public_path__ + "img/tit1.eace1d2b.png";